// ── Szerviz árlista – EGYETLEN forrás ────────────────────────────────────────
//
// Ez a fájl a /szerviz oldal árlistájának KANONIKUS helye. Korábban a táblák
// a ServicePage.jsx-ben álltak, a landing oldalak pedig egy külön, kézzel írt
// „13 000 Ft-tól” konstansból dolgoztak – így az iPhone akkumulátor-landing
// MINDEN modellre 13 000 Ft-ot írt ki, miközben az árlista szerint a legolcsóbb
// iPhone akku 20 000 Ft. Élesben derült ki, a vevőnek a valósnál ~40%-kal
// olcsóbb árat mutattunk.
//
// Szabály: árat CSAK innen szabad megjeleníteni. Ha egy modellre nincs adat,
// az oldal NE találjon ki számot – lásd `akkuArSzoveg` (null-t ad vissza).

/** Kijelzőcsere – utángyártott / eredeti (Ft, ezres ponttal, ahogy megjelenik). */
export const KIJELZO_ARAK = [
  { model: 'iPhone 11 (LCD)',           aftermarket: '25.000',  original: '40.000' },
  { model: 'iPhone 11 Pro (OLED)',      aftermarket: '30.000',  original: '55.000' },
  { model: 'iPhone 11 Pro Max (OLED)',  aftermarket: '35.000',  original: '55.000' },
  { model: 'iPhone SE 2020',            aftermarket: '20.000',  original: '25.000' },
  { model: 'iPhone 12 mini',            aftermarket: '-',       original: '50.000' },
  { model: 'iPhone 12/12 Pro (OLED)',   aftermarket: '45.000',  original: '55.000' },
  { model: 'iPhone 12 Pro Max (OLED)',  aftermarket: '45.000',  original: '65.000' },
  { model: 'iPhone 13 mini',            aftermarket: '-',       original: '65.000' },
  { model: 'iPhone 13',                 aftermarket: '45.000',  original: '65.000' },
  { model: 'iPhone 13 Pro (120Hz)',     aftermarket: '70.000',  original: '110.000' },
  { model: 'iPhone 13 Pro Max',         aftermarket: '70.000',  original: '110.000' },
  { model: 'iPhone 14',                 aftermarket: '50.000',  original: '80.000' },
  { model: 'iPhone 14 Plus',            aftermarket: '60.000',  original: '100.000' },
  { model: 'iPhone 14 Pro (120Hz)',     aftermarket: '80.000',  original: '130.000' },
  { model: 'iPhone 14 Pro Max (120Hz)', aftermarket: '100.000', original: '140.000' },
  { model: 'iPhone 15',                 aftermarket: '80.000',  original: '100.000' },
  { model: 'iPhone 15 Plus',            aftermarket: '70.000',  original: '100.000' },
  { model: 'iPhone 15 Pro',             aftermarket: '90.000',  original: '140.000' },
  { model: 'iPhone 15 Pro Max',         aftermarket: '120.000', original: '170.000' },
  { model: 'iPhone 16',                 aftermarket: '90.000',  original: '130.000' },
  { model: 'iPhone 16 Plus',            aftermarket: '90.000',  original: '130.000' },
  { model: 'iPhone 16 Pro',             aftermarket: '110.000', original: '170.000' },
  { model: 'iPhone 16 Pro Max',         aftermarket: '-',       original: '180.000' },
];

/** Akkumulátorcsere – utángyártott / eredeti. CSAK iPhone: Samsung/Xiaomi
 *  árlistánk nincs, ezért azokra a landing a saját „-tól” címkéjét használja. */
export const AKKU_ARAK = [
  { model: 'iPhone 11',         aftermarket: '20.000', original: '-' },
  { model: 'iPhone 11 Pro',     aftermarket: '20.000', original: '-' },
  { model: 'iPhone 11 Pro Max', aftermarket: '25.000', original: '-' },
  { model: 'iPhone SE 2020',    aftermarket: '20.000', original: '-' },
  { model: 'iPhone 12 mini',    aftermarket: '20.000', original: '-' },
  { model: 'iPhone 12/12 Pro',  aftermarket: '25.000', original: '45.000' },
  { model: 'iPhone 12 Pro Max', aftermarket: '25.000', original: '45.000' },
  { model: 'iPhone 13 mini',    aftermarket: '25.000', original: '-' },
  { model: 'iPhone 13',         aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 13 Pro',     aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 13 Pro Max', aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 14',         aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 14 Plus',    aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 14 Pro',     aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 14 Pro Max', aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 15',         aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 15 Plus',    aftermarket: '30.000', original: '45.000' },
  { model: 'iPhone 15 Pro',     aftermarket: '35.000', original: '45.000' },
  { model: 'iPhone 15 Pro Max', aftermarket: '35.000', original: '45.000' },
  { model: 'iPhone 16',         aftermarket: '35.000', original: '-' },
  { model: 'iPhone 16 Plus',    aftermarket: '35.000', original: '-' },
  { model: 'iPhone 16 Pro',     aftermarket: '35.000', original: '-' },
  { model: 'iPhone 16 Pro Max', aftermarket: '35.000', original: '-' },
];

/** '20.000' → 20000. Hiányzó ('-') érték → null. */
export const arSzam = (s) => {
  const d = String(s ?? '').replace(/[^\d]/g, '');
  return d ? Number(d) : null;
};

/** 20000 → '20 000 Ft' (magyar ezres-elválasztás, nem törhető szóközzel). */
export const arFormat = (n) =>
  (typeof n === 'number' && Number.isFinite(n))
    ? `${n.toLocaleString('hu-HU').replace(/ /g, ' ')} Ft`
    : null;

/** Modellnév normalizálás az összepárosításhoz: kisbetű, csak alfanumerikus.
 *  Így a kalkulátor „iPhone 13 Mini” és az árlista „iPhone 13 mini” egyezik. */
const norm = (s) => String(s ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');

/** Árlista-sor → a sor által LEFEDETT modellnevek.
 *  Az „iPhone 12/12 Pro” egyetlen sor, de két modellre vonatkozik; a
 *  zárójeles műszaki megjegyzés (OLED, 120Hz) nem része a modellnévnek. */
export const sorModelljei = (rowModel) => {
  const tiszta = String(rowModel ?? '').replace(/\s*\([^)]*\)/g, '').trim();
  const slash = tiszta.match(/^(iPhone\s+(\d+))\/(.+)$/i);
  if (slash) return [slash[1], `iPhone ${slash[3]}`.replace(/^iPhone\s+iPhone/i, 'iPhone')];
  return [tiszta];
};

const indexel = (rows) => {
  const map = new Map();
  rows.forEach((row) => sorModelljei(row.model).forEach((m) => {
    if (!map.has(norm(m))) map.set(norm(m), row);
  }));
  return map;
};
const AKKU_INDEX = indexel(AKKU_ARAK);
const KIJELZO_INDEX = indexel(KIJELZO_ARAK);

/** Egy modell akku-ára az árlistából, vagy `null`, ha nincs rá adat. */
export const akkuAr = (model) => AKKU_INDEX.get(norm(model)) || null;
/** Egy modell kijelző-ára az árlistából, vagy `null`. */
export const kijelzoAr = (model) => KIJELZO_INDEX.get(norm(model)) || null;

/** A megjelenítendő ár: az utángyártott, ha van, különben az eredeti. */
const megjelenitendo = (row) => (row ? (arSzam(row.aftermarket) ?? arSzam(row.original)) : null);

/**
 * Egy modell akkumulátorcseréjének ára szövegként („25 000 Ft”), vagy `null`,
 * ha az árlistában nincs rá adat. A `null`-t a hívónak KEZELNIE kell –
 * szándékosan nem adunk vissza kitalált „-tól” számot.
 */
export const akkuArSzoveg = (model) => arFormat(megjelenitendo(akkuAr(model)));

/** A LEGOLCSÓBB iPhone akkumulátorcsere az árlistából, „…-tól” alakban. */
export const akkuMinArSzoveg = () => {
  const arak = AKKU_ARAK.map(megjelenitendo).filter((v) => typeof v === 'number');
  return arak.length ? `${arFormat(Math.min(...arak))}-tól` : null;
};

/**
 * A LEGOLCSÓBB iPhone kijelzőcsere az árlistából, „…-tól” alakban.
 * @param {'aftermarket'|'original'} oszlop  utángyártott vagy gyári Apple
 */
export const kijelzoMinArSzoveg = (oszlop = 'aftermarket') => {
  const arak = KIJELZO_ARAK.map((r) => arSzam(r[oszlop])).filter((v) => typeof v === 'number');
  return arak.length ? `${arFormat(Math.min(...arak))}-tól` : null;
};
